import 'react-app-polyfill/stable'
import 'core-js'
// First: production builds silence console.log/info/debug (see utils/quietConsole.js).
import './utils/quietConsole'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store/index'
import './i18n'
import { prePaintBrand } from './brand/prePaint'
import { capturePinnedBrand } from './brand/pinnedBrand'

// Airline staff returning to their sign-in page get their airline's colours before first paint.
capturePinnedBrand()
prePaintBrand()

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
